


















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import Switcher from '@/components/Switcher.vue';
import Page from '@/components/Page.vue';
import Map from '@/components/Map.vue';
import OversizedCheck from '@/modules/reservation/components/OversizedCheck.vue';
import OversizedModal from '@/modules/reservation/components/OversizedModal.vue';
import SearchStore from '@/store/SearchStore';
import SearchBar from '@/components/SearchBar.vue';
import { DatetimeService } from '@/services/DatetimeService';
import { EnumReservationType, EnumSearchType, Search } from '@/models/Search';

@Component({
  components: {
    Topbar,
    Switcher,
    Page,
    OversizedCheck,
    OversizedModal,
    Map,
    SearchBar,
  },
})
export default class SearchResults extends Vue {
  public search: Search = new Search();

  public ready: boolean = false;

  public reservationTypeOptions: any[] = [
    {
      id: EnumReservationType.HOURLY,
      label: 'Hourly',
    },
    {
      id: EnumReservationType.MONTHLY,
      label: 'Monthly',
    },
  ];

  public results: any[] = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
      disabled: true,
    },
    {
      id: 4,
    },
  ];

  public $refs!: {
    modalOversized: OversizedModal;
  };

  public get searchDetails() {
    return SearchStore.currentSearch;
  }

  public changeReservationType(id: EnumReservationType) {
    this.search.type = id;
  }

  public changeView() {
    if (this.search.searchType === EnumSearchType.MAP) {
      this.search.searchType = EnumSearchType.LIST;
    } else {
      this.search.searchType = EnumSearchType.MAP;
    }
  }

  public showOversizedInfo() {
    this.$refs.modalOversized.open();
  }

  public async mounted() {
    await SearchStore.RestoreSearch().then(() => {
      this.search = new Search(SearchStore.currentSearch);
    }).finally(() => {
      this.ready = true;
    });
  }

  @Watch('search', { immediate: false, deep: true })
  public onSearchChanged(val: any, oldVal: any) {
    // console.log(val, oldVal);
    SearchStore.Search(this.search);
  }
}
